import { render, staticRenderFns } from "./activities.vue?vue&type=template&id=2390ee78&scoped=true"
import script from "./activities.vue?vue&type=script&lang=js"
export * from "./activities.vue?vue&type=script&lang=js"
import style0 from "./activities.vue?vue&type=style&index=0&id=2390ee78&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2390ee78",
  null
  
)

export default component.exports